import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../lib/api";
import { useAuth } from "../contexts/AuthContext";

// Handles Emergent OAuth callback. Detected synchronously in App.jsx by hash.
const AuthCallback = () => {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/login");
      return;
    }
    const session_id = decodeURIComponent(match[1]);
    (async () => {
      try {
        const { data } = await apiClient.post("/auth/google/session", { session_id });
        if (data?.token) localStorage.setItem("auth_token", data.token);
        await refresh();
        // strip the hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/account", { replace: true });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center" data-testid="auth-callback">
      <div className="text-ink-muted">Signing you in…</div>
    </div>
  );
};

export default AuthCallback;
